export default "__VITE_ASSET__CumLazqH__"